import { RichTextEditor } from "../RichTextEditor";
import type { Block } from "@/types/proposals";

interface TextBlockProps {
  block: Block;
  onUpdate: (updates: Partial<Block>) => void;
  onSelect: () => void;
  isPreview?: boolean;
}

export function TextBlock({ block, onUpdate, onSelect, isPreview = false }: TextBlockProps) {
  const handleTextChange = (text: string) => {
    if (!isPreview) {
      onUpdate({ content: { ...block.content, text } });
    }
  };

  const blockSize = block.settings?.blockSize || 'medium';
  const textAlign = block.style?.textAlign || 'left';

  const sizeClass = {
    small: 'text-sm',
    medium: 'text-base',
    large: 'text-lg',
  }[blockSize];

  const alignClass = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right',
  }[textAlign];

  return (
    <div 
      className={`h-full w-full ${sizeClass} ${alignClass}`}
    >
      <RichTextEditor
        value={block.content.text || ""}
        onChange={handleTextChange}
        style={block.style}
        placeholder="Type text here or {{ to insert smart fields..."
        readOnly={isPreview}
      />
    </div>
  );
}
